import {useTranslation} from "react-i18next";
import {GenerateInputs} from "../GenericInputField";
import React, {useRef} from "react";
import lodash from "lodash";
import snackbar from "../../snackbar";
import {apiPut} from "../../api";
import confirmationDialog from "../../confirmationDialog";
import Typography from "@material-ui/core/Typography";
import {ValidatorForm} from "react-form-validator-core";


function ConfirmAndSend(props) {

    const {t, _} = useTranslation();
    let inputs = GenerateInputs({
        send_a_copy: {
            defaultValue: false,
            label: t("ui_dialog_send_a_copy"),
            type: 'checkbox'
        },
        message: {
            defaultValue: props.globalComment,
            label: t("dialog_plh_confirm"),
            type: "textarea"
        }
    });

    let inputRef = useRef(null);

    let submit = () => {
        let signatures = [];
        let allSigned = true;
        for (let page of props.data.document.pages) {
            if (!page.placeholders) {
                continue;
            }
            for (let placeholder of page.placeholders) {
                let sindex = lodash.find(props.data.signers, {
                    id: placeholder.signer_id
                });

                if (!(placeholder.image || placeholder._image || placeholder.signed)) {
                    allSigned = false;
                }

                if (props.signerID && sindex && sindex.unique_id === props.signerID && placeholder._image) {
                    signatures.push({
                        id: placeholder.id,
                        html_image: placeholder._image,
                        text: placeholder._text,
                        text_color: placeholder._text_color,
                        text_font: placeholder._text_font
                    })
                }
            }

        }

        if (!signatures.length) {
            snackbar(t("signatures_missing"));
            return false;
        }
        props.dialog.setState({
            okDisabled: true,
            cancelDisabled: true
        });
        let datax = {
            signatures: signatures,
            message: inputs.message.value,
            signed: true,
            send_a_copy: false,
        };
        if (inputs.send_a_copy.value) {
            datax.send_a_copy = true;
        }
        return apiPut("sign_request_for_signer/" + props.signerID, datax).then((res) => {
            window.formDirty = false;
            props.reloadData();
            let okText, title, ok, body, dialog, cancelText;
            if (allSigned) {
                body = t("signed_doc_download");
                title = t("signed_doc_download_title");
                cancelText = t("Ok");
                okText = false;
                ok = false;
                // () => {
                //                     props.documentDownload();
                //                 }
            } else {
                body = t("signed_doc_wait");
                title = t("signed_doc_wait_title");
                cancelText = false;
                okText = t("Ok");
                ok = () => {
                    dialog.close();
                };
            }

            setTimeout(() => {
                dialog = {
                    title: title,
                    ok: ok,
                    cancelText: cancelText,
                    cancel: () => {
                        dialog.close();
                    },
                    okText: okText,
                };
                dialog.content = <div>{body}</div>;
                confirmationDialog(dialog);
            }, 500);

        }, function () {
            props.dialog.setState({
                okDisabled: false,
                cancelDisabled: false
            });
        });
    };

    props.dialog.ok = () => {
        return submit();
    };


    return <div style={{minWidth: 300}}>
        <Typography
            variant={"body1"}>{props.data && props.data.sign_request.comment_help_text ? props.data.sign_request.comment_help_text : t("signed_comment")}</Typography>
        <div>
            <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                <div>
                    {inputs.message.field}
                </div>
                <div>
                    {inputs.send_a_copy.field}
                </div>
            </ValidatorForm>
        </div>
    </div>
}

export default ConfirmAndSend;